
<!--Header and subtitle-->
<div class="fdx-o-grid__row fdx-o-grid__row--center">
  <div class="fdx-o-grid__item--12@small-only fdx-u-align--center">
    <ng-container>
      <div class="fdx-u-align--center">
        <h1 class="fdx-c-header fdx-c-header--h2 fdx-u-mb--3" id="otpFormTitle">
          {{ 'verificationMethod.verifyYourIdentityHeader' | translate}}
        </h1>
      </div>
      <div class="fdx-u-my--4 fdx-u-align--center"
        aria-atomic="true" aria-live="assertive">
        <h2 class="fdx-c-paragraph fdx-u-mb--0" id="otpFormSubtitle">
          <ng-container>
            @switch (method) {
              @case ('SMS') {
                <span [id]="method + 'SubtitleOne'" [innerHTML]="'stepUpPopup.smsSubTitle' | translate: { smsNumber: value ? value : '' }"></span>
              }
              @case ('EMAIL') {
                <span [id]="method + 'SubtitleOne'" [innerHTML]="'stepUpPopup.emailSubTitle' | translate: { emailAddress: value ? value : '' }"></span>
              }
              @case ('CALL') {
                <span [id]="method + 'SubtitleOne'" [innerHTML]="'stepUpPopup.phoneSubTitle' | translate: { phoneNumber: value ? value : '' }"></span>
              }
            }
          </ng-container>
        </h2>
      </div>
    </ng-container>
    
  <!--Adding the Form input fields containing the 6 digit verification code -->
    <div class="fdx-o-grid fdx-o-grid--max-width">
      <div class="fdx-o-grid__row fdx-o-grid__row--center">
        <div class="fdx-o-grid__item--6 fdx-u-align--left">
          <div class="fdx-u-display--flex fdx-u-flex-justify-content--center fdx-u-pb--4">
            <form [formGroup]="verificationCodeForm">
              <div class="fdx-c-single-digits">
                <fieldset class="fdx-c-single-digits__fieldset">
                  <legend class="fdx-c-single-digits__legend">{{ 'enterPinPopup.enterCode' | translate }}</legend>
                  @for (digit of digits; track digit; let i = $index;) {
                    <div class="fdx-c-single-digits__item">
                      <input type="number" autocomplete="one-time-code" min="0" id="input{{i+1}}" attr.aria-label="Verification Code Digit {{i+1}}"
                        formControlName="{{digit}}" class="fdx-c-single-digits__item__input paddingWCiOS" maxlength="1" size="1" contenteditable="true"
                        name="auth-token"  inputmode="numeric" pattern="[0-9]*"
                        (keypress)="onKeyPress($event, i)"
                        (keyup)="onValueChange($event, i)"
                        (click)="onClickEvent(i)"
                        (blur)="onBlurEvent(i)"
                        (keydown)="onKeyDown($event, i)"
                        (paste)="pasteValues($event)"
                        (input)="handleChange()">
                    </div>
                  }
                </fieldset>
              </div>
              <div class="fdx-c-form-message fdx-u-flex-align-items--start fdx-u-mt--2 fdx-u-mb--2 fdx-u-pl--0 fdx-u-pt--0 fdx-o-grid__item--11@large fdx-u-align--left"
                role="alert">
                {{ 'stepUpPopup.codeValidity' | translate }}
              </div>
              @if (verificationCodeForm.invalid) {
                <div class="fdx-c-form-message--error fdx-u-font-size--super-small fdx-u-mb--1"
                  id="verificationFormInvalid">
                  @if (!expiredAndIncorrectError && toggleElement && (digitValidStatus
                    ||((verificationCodeForm.controls['digit1'].invalid && ( verificationCodeForm.controls['digit1'].dirty || verificationCodeForm.controls['digit1'].touched )) || (verificationCodeForm.controls['digit1'].invalid && formSubmit))
                    || ((verificationCodeForm.controls['digit2'].invalid && ( verificationCodeForm.controls['digit2'].dirty || verificationCodeForm.controls['digit2'].touched )) || (verificationCodeForm.controls['digit2'].invalid && formSubmit))
                    || ((verificationCodeForm.controls['digit3'].invalid && ( verificationCodeForm.controls['digit3'].dirty || verificationCodeForm.controls['digit3'].touched )) || (verificationCodeForm.controls['digit3'].invalid && formSubmit))
                    || ((verificationCodeForm.controls['digit4'].invalid && ( verificationCodeForm.controls['digit4'].dirty || verificationCodeForm.controls['digit4'].touched )) || (verificationCodeForm.controls['digit4'].invalid && formSubmit))
                    || ((verificationCodeForm.controls['digit5'].invalid && ( verificationCodeForm.controls['digit5'].dirty || verificationCodeForm.controls['digit5'].touched )) || (verificationCodeForm.controls['digit5'].invalid && formSubmit))
                    || ((verificationCodeForm.controls['digit6'].invalid && ( verificationCodeForm.controls['digit6'].dirty || verificationCodeForm.controls['digit6'].touched )) || (verificationCodeForm.controls['digit6'].invalid && formSubmit)))) {
                      <div class="fdx-c-form-message fdx-c-form-message--error fdx-u-pl--0 fdx-u-pt--1"
                          role="alert">
                        <div class="fdx-u-mr--0">
                          <div style="mask-position: center">
                            <ciam-icon [color]="'red'" [key]="'utility_cross-fat'"></ciam-icon>
                          </div>
                        </div>
                        {{ 'enterPinPopup.codeRequiredError' | translate }}
                      </div>
                    }
                </div>
              }
              @if (expiredAndIncorrectError) {
                <div class="fdx-c-form-message fdx-u-flex-align-items--start fdx-c-form-message--error fdx-u-mb--2 fdx-u-pl--0 fdx-u-pt--0 fdx-o-grid__item--11@large fdx-u-align--left"
                role="alert">
                  <div class="fdx-u-mr--0 fdx-u-mb--3">
                    <div style="mask-position: center">
                      <ciam-icon [color]="'red'" [key]="'utility_cross-fat'"></ciam-icon>
                    </div>
                  </div>
                  {{ 'enterPinPopup.codeExpired' | translate }}
                </div>
              }
              @if (systemUnavailableError) {
                <div class="fdx-c-form-message fdx-u-flex-align-items--start fdx-c-form-message--error fdx-u-mb--2 fdx-u-pl--0 fdx-u-pt--0 fdx-o-grid__item--11@large fdx-u-align--left"
                      role="alert">
                  <div class="fdx-u-mr--0 fdx-u-mb--3">
                    <div style="mask-position: center">
                      <ciam-icon [color]="'red'" [key]="'utility_cross-fat'"></ciam-icon>
                    </div>
                  </div>
                  {{ 'enterPinPopup.apiError' | translate }}
                </div>                  
              }
            </form>
          </div>
        </div>
      </div>
    </div>
  
  <!-- continue button -->
    <div class="fdx-o-grid__item fdx-o-grid__item--12 fdx-u-align--center fdx-u-mb--3 fdx-u-mt--7">
      <button id="continue-btn" #submitBtn (click)="validatePin()"
      class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive fdx-u-text--uppercase"
      aria-atomic="true" aria-live="assertive">
      {{ 'common.continue' | translate }}
      </button>
    </div>

  <!-- Request New code button -->
    <div class="fdx-u-align--center">
      <a tabindex="0" id="requestCode-btn" (click)="resendPin()"
        class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive" aria-atomic="true"
        aria-live="assertive">{{ 'enterPinPopup.requestNewCode' | translate }}</a>
    </div>

  <!-- Use a different verification method button -->
   @if (useDiffMethodLink) {
     <div class="fdx-u-align--center">
       <button id="verifyOptionsLink-btn" (click)="changeChannel.next({}); changeChannel.complete()"
               class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive fdx-u-align--center" aria-atomic="true"
               aria-live="assertive">{{ 'stepUpPopup.differentVerificationMethod' | translate }}</button>
     </div>
   }
</div>
